import { useState } from "react";

import { apiRequest } from "./api";

const constitutionOptions = [
  "Public Ltd",
  "Private Ltd",
  "LLP",
  "Proprietorship",
  "Partnership",
  "Trust",
];

const countryCodeOptions = [
  { value: "+91", label: "India (+91)" },
  { value: "+1", label: "USA (+1)" },
  { value: "+44", label: "UK (+44)" },
  { value: "+61", label: "Australia (+61)" },
  { value: "+81", label: "Japan (+81)" },
];

const initialForm = {
  business_name: "",
  business_code: "",
  constitution: "",
  contact_person_name: "",
  country_code: "+91",
  contact_person_number: "",
  contact_person_email: "",
  address_line1: "",
  address_line2: "",
};

export default function SignupView({ onBackToLogin, onOtpSent }) {
  const [formValues, setFormValues] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  function updateField(field, value) {
    setFormValues((current) => ({ ...current, [field]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setStatus("");
    setError("");

    try {
      const payload = await apiRequest("/auth/signup/", {
        method: "POST",
        body: JSON.stringify(formValues),
      });
      setStatus(payload.message || "OTP sent successfully.");
      onOtpSent(payload.email || formValues.contact_person_email);
    } catch (requestError) {
      setError(requestError.message || "Unable to start signup.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="auth-panel auth-panel--signup">
      <div className="auth-panel__header">
        <p className="eyebrow">Company Signup</p>
        <h2>Register your company workspace</h2>
        <p className="config-note">
          Submit your company details to receive an OTP verification email and continue account
          setup in the existing Django registration flow.
        </p>
      </div>

      {status ? <p className="config-banner config-banner--success">{status}</p> : null}
      {error ? <p className="form-error">{error}</p> : null}

      <form className="auth-form auth-form--signup" onSubmit={handleSubmit}>
        <label>
          Business Name
          <input
            type="text"
            name="business_name"
            value={formValues.business_name}
            onChange={(event) => updateField("business_name", event.target.value)}
            required
          />
        </label>

        <label>
          Business Code
          <input
            type="text"
            name="business_code"
            value={formValues.business_code}
            onChange={(event) => updateField("business_code", event.target.value)}
            required
          />
        </label>

        <label>
          Constitution
          <select
            name="constitution"
            value={formValues.constitution}
            onChange={(event) => updateField("constitution", event.target.value)}
            required
          >
            <option value="">Select constitution</option>
            {constitutionOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </label>

        <label>
          Contact Person Name
          <input
            type="text"
            name="contact_person_name"
            value={formValues.contact_person_name}
            onChange={(event) => updateField("contact_person_name", event.target.value)}
            required
          />
        </label>

        <label>
          Country Code
          <select
            name="country_code"
            value={formValues.country_code}
            onChange={(event) => updateField("country_code", event.target.value)}
            required
          >
            {countryCodeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label>
          Contact Person Number
          <input
            type="tel"
            name="contact_person_number"
            value={formValues.contact_person_number}
            onChange={(event) => updateField("contact_person_number", event.target.value)}
            required
          />
        </label>

        <label className="auth-form__full">
          Contact Person Email
          <input
            type="email"
            name="contact_person_email"
            value={formValues.contact_person_email}
            onChange={(event) => updateField("contact_person_email", event.target.value)}
            required
          />
        </label>

        <label className="auth-form__full">
          Address Line 1
          <textarea
            name="address_line1"
            rows="3"
            value={formValues.address_line1}
            onChange={(event) => updateField("address_line1", event.target.value)}
            required
          />
        </label>

        <label className="auth-form__full">
          Address Line 2 (Optional)
          <textarea
            name="address_line2"
            rows="2"
            value={formValues.address_line2}
            onChange={(event) => updateField("address_line2", event.target.value)}
          />
        </label>

        <div className="auth-form__actions auth-form__full">
          <button className="primary-button" type="submit" disabled={submitting}>
            {submitting ? "Submitting..." : "Register"}
          </button>
          <button className="ghost-button" type="button" onClick={onBackToLogin}>
            Back to Sign In
          </button>
        </div>
      </form>
    </section>
  );
}
